import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { OTHER_INCOME_STRUCTURE_ID } from 'src/Enum/IncomeStructure';
import { useIncomeStructure } from '../IncomeStructureProvider/IncomeStructureProvider';
import { findMasterDataById } from '../utils';
import ProductIncomeYearFieldsPct from './ProductIncomeYearFieldsPct';

const ProductIncomeOtherPct = () => {
  const { productIncome } = useIncomeStructure();

  const otherProductIncomePct = findMasterDataById(
    productIncome,
    OTHER_INCOME_STRUCTURE_ID.OTHER_PRODUCT_INCOME
  );

  return (
    <>
      {otherProductIncomePct && (
        <Flex width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350}>
            <InputLabel sx={{ textAlign: 'right' }}>
              {otherProductIncomePct.nameTh}
            </InputLabel>
            <Typography textAlign={'right'} color={'text.secondary'}>
              (%)
            </Typography>
          </Box>
          <ProductIncomeYearFieldsPct
            keyItem={otherProductIncomePct.id.toString()}
          />
        </Flex>
      )}
    </>
  );
};

export default ProductIncomeOtherPct;
